<template>
  <div>
    <label>*{{word.cancel_reason}}</label>
    <cancel-reason v-model="cancel_reason_id"></cancel-reason>
    <div class="form-group">
      <label for="cancel_reason_comment">{{word.description}}</label>
      <textarea id="cancel_reason_comment" v-model="cancel_reason_comment" class="form-control"></textarea>
    </div>
    <button @click.prevent="post" type="buttom" class="ps-btn">{{word.cancel_task}}</button>
  </div>
</template>

<script>
import CancelReason from "./../../CancelReason";
export default {
  components: { CancelReason },
  props: {
    task_id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      word: {},
      text: {},
      cancel_reason_id: null,
      cancel_reason_comment: ""
    };
  },
  created() {
    this.word = window.word;
    this.text = window.text;
  },
  methods: {
    post() {
      this.$Progress.start();
      this.showEditBtn = false;
      let self = this;
      let data = {
        cancel_reason_id: self.cancel_reason_id,
        cancel_reason_comment: self.cancel_reason_comment
      };

      axios({
        method: "post",
        url: "/dashboard/task/" + self.task_id + "?_method=delete",
        data
      })
        .then(function(res) {
          self.$Progress.finish();
          if (res.data.ok) {
            self.$toast.success(res.data.msg);
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            self.$toasted.show(res.data.msg, {
              theme: "bubble",
              position: "top-center",
              duration: 5000
            });
            self.$Progress.fail();
          }
        })
        .catch(function(e) {
          self.$Progress.fail();
          if (e.response.status == 422) {
            self.errors = e.response.data.errors;
            console.log(self.errors);
            for (let error in self.errors) {
              self.$toast.error(self.errors[error][0]);
            }
          } else {
            console.log(e);
          }
        });
    }
  }
};
</script>
